import React from "react";
import { motion } from "framer-motion";
import { cn } from "../shadcn/utils";
import { Spinner } from "@/react/icons";

export function OptionButton({
  className,
  index = 0,
  onClick,
  logo,
  logoKey,
  children,
  disabled = false,
  ...props
}: {
  className?: string;
  index?: number;
  onClick?: () => void;
  logo?: string;
  logoKey?: string;
  children?: React.ReactNode;
  disabled?: boolean;
}) {
  return (
    <motion.button
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.1 * (index + 1) }}
      onClick={onClick}
      className={cn(
        "web3kit-flex web3kit-justify-between web3kit-h-12 web3kit-items-center web3kit-rounded-xl web3kit-px-4 web3kit-py-2 web3kit-text-lg web3kit-font-semibold web3kit-shadow-md web3kit-bg-muted web3kit-gap-x-2 web3kit-w-full",
        disabled
          ? "web3kit-bg-muted web3kit-text-muted-foreground"
          : "hover:web3kit-bg-accent hover:web3kit-shadow-xl",
        className
      )}
      disabled={disabled}
      {...props}
    >
      <div className="web3kit-leading-none">{children}</div>
      {disabled ? (
        <Spinner className="web3kit-size-8 web3kit-animate-spin" />
      ) : typeof logo === "string" ? (
        <motion.img
          key={logoKey || logo}
          src={logo}
          alt={`${index} logo`}
          className="web3kit-size-8 web3kit-overflow-hidden web3kit-rounded-lg"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{
            duration: 0.3,
            ease: "easeInOut",
          }}
        />
      ) : (
        logo
      )}
    </motion.button>
  );
}
